<template>
  <CHeader fixed light>
    <CToggler
      in-header
      class="d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mr-auto d-lg-none" to="/">
      <div class="mobile-logo">
        <a href="index.html"
          ><img
            src="@/images/logo.png"
            alt="Reeracoen Freelance Recruiting Business"
        /></a></div
    ></CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard">
          <div class="desktop-logo">
            <a href="index.html"
              ><img
                src="@/images/logo.png"
                alt="Reeracoen Freelance Recruiting Business"
            /></a>
          </div>
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class=""
      ><a class="btn btn-outline" href="#">Login</a></CHeaderNav
    >
  </CHeader>
</template>

<script>
export default {
  name: "TheHeader",
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
.c-header {
  background: $white;
  border-bottom: 0;
  padding: 1rem 1.5rem;
  padding-top: 1.5rem;
  .c-header-nav {
    .desktop-logo {
      img {
        width: 170px;
      }
    }
  }
  .btn {
    padding: 0.75rem 2rem;
    width: 120px;
  }
}
.c-header-toggler-icon {
  /* stylelint-disable-next-line declaration-no-important */
  background-image: url("bar.svg") !important;
  height: 1.5rem;
  margin-left: -1rem;
}
@media only screen and (max-width: 991px) {
  .c-header {
    padding: 1rem 1rem;
    .c-header-brand {
      display: inline-flex;
      .mobile-logo {
        img {
          width: 150px;
        }
      }
    }
    .btn {
      padding: 0.5rem 1rem;
      width: auto;
    }
  }
  .c-header-toggler-icon {
    height: 2rem;
  }
}
</style>
